import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { LicenseStatusResponse } from "@/api/types";

const REFETCH_MS = 60_000; // 1 min: el license_client publica cada hora; chequeo más frecuente sería ruido.

export function useLicenseStatus() {
  return useQuery({
    queryKey: ["license-status"],
    queryFn: ({ signal }) =>
      api<LicenseStatusResponse>("/api/v1/license/status", { signal }),
    refetchInterval: REFETCH_MS,
    placeholderData: (prev) => prev,
  });
}
